import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Hero from '../../components/Hero';
import About from '../../components/About';
import ServicesHome from '../../components/Services';
import Industries from '../../components/Industries';
import ProjectsHome from '../../components/Projects';
import CareersHome from '../../components/Careers';
import Contact from '../../components/Contact';

export default function HomePage() {
  const { scrollToSection } = useOutletContext();

  return (
    <div className="App">
      <Hero scrollToSection={scrollToSection} />
      <About />
      <ServicesHome />
      <Industries />
      <ProjectsHome />
      <CareersHome />
      <Contact />
    </div>
  );
}
